<template>
   <div
   class="grid-item"
   :class="`grid-${size}`"
   v-scroll-reveal>

      <carousel
      :adjustableHeight="false"
      :autoplay="autoplay"
      :autoplayTimeout="5000"
      easing="cubic-bezier(0.22, 0.61, 0.36, 1)"
      :loop="true"
      :navigationClickTargetSize="5"
      :navigationEnabled="true"
      :paginationPadding="2"
      :paginationActiveColor="color"
      paginationColor="#CBD2D9"
      :perPage="1"
      >
        <slot />
      </carousel>

   </div>
</template>

<script>
import { Carousel } from 'vue-carousel'

export default {
  components: { Carousel },
  props: {
    'size': { type: String, default: '50' },
    'autoplay': { type: Boolean, default: false },
    'color': { type: String }
  },
  methods: {
    resizeSlider () {
      let carousel = document.querySelector('.VueCarousel-inner')
      let carouselImages = carousel.querySelectorAll('.VueCarousel-slide')
      let carouselImgHeight = carouselImages[0].clientHeight
      console.log(carouselImgHeight)
      carousel.style.height = `${carouselImgHeight}px`
    }
  },
  mounted () {
    setTimeout(() => {
      // this.resizeSlider();
    }, 100)
  }

}
</script>

<style lang="scss" scoped>
.grid-item {
    background: transparent;
    box-shadow: none;
}

</style>
